"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Tabs = require("../Tabs.types");
require("./TabHeader.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HOVER_DELAY = 200;
const TabHeader = _ref => {
  let {
    title,
    isActive,
    onTrigger,
    triggerType = _Tabs.TABS_TRIGGER_TYPE.click,
    className,
    dataAttributes
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Tab', {
    'cds-Tab--Active': isActive
  }, className);
  const timeoutIdRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, []);
  const handleHover = title => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    switch (triggerType) {
      case _Tabs.TABS_TRIGGER_TYPE.none:
        break;
      case _Tabs.TABS_TRIGGER_TYPE.hover:
        onTrigger(title);
        break;
      case _Tabs.TABS_TRIGGER_TYPE.hoverDelayed:
        timeoutIdRef.current = setTimeout(() => onTrigger(title), HOVER_DELAY);
        break;
    }
  };
  const handleClick = title => {
    if (triggerType !== _Tabs.TABS_TRIGGER_TYPE.none) {
      onTrigger(title);
    }
  };
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName,
    onClick: () => handleClick(title),
    onMouseEnter: () => handleHover(title),
    onMouseLeave: () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    }
  }), title);
};
exports.TabHeader = TabHeader;
//# sourceMappingURL=TabHeader.js.map